import React from 'react';
import Link from 'next/link';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { SBackBtn } from '~/src/features/service/knowledgebase/styled';


type TProps = {
    url: string,
    as: string,
    text: string,
}

export const BackBtn: React.FC<TProps> = ({ url, text, as }) => {
    return (
        <Link
            href={url}
            as={as}
            passHref
        >
            <SBackBtn
                type={btnTypes.GHOST}
                text={text}
                iconsSprite={'/static/images/icons/arrow_left_sprite.svg'}
                symbolId={'back-arrow'}
            />
        </Link>
    );
};
